(function($) {
  $('.navbar-toggler').on('click', function(){
    $($(this).data('target')).toggleClass('open');
    $('body').toggleClass('overflow-y-hidden');
  });
})(jQuery)
